const getTabLabel = (tab) => tab?.textContent?.trim() || '';

const getTabKey = (label) =>
  label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const installSidePanelTabIdentity = (container) => {
  if (!container) {
    return () => {};
  }

  let syncTimer;

  const syncTabIdentity = () => {
    const tabs = Array.from(container.querySelectorAll('.polotno-side-panel-tab'));

    tabs.forEach((tab) => {
      const key = getTabKey(getTabLabel(tab));

      if (key) {
        tab.dataset.olcSideTab = key;
      }
    });
  };

  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncTabIdentity, 0);
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(container, { childList: true, subtree: true });
  scheduleSync();

  return () => {
    window.clearTimeout(syncTimer);
    observer.disconnect();
  };
};

export const installRealPennedFieldsDefault = (container) => {
  if (!container) {
    return () => {};
  }

  let openTimer;
  let settled = false;

  const openFieldsWhenReady = () => {
    const tabs = Array.from(container.querySelectorAll('.polotno-side-panel-tab'));

    if (!tabs.length) {
      return false;
    }

    const isRealPennedSidebar =
      tabs.length === 2 &&
      getTabLabel(tabs[0]) === 'Templates' &&
      getTabLabel(tabs[1]) === 'Fields';

    if (!isRealPennedSidebar) {
      settled = true;
      return true;
    }

    // Do not override a choice the user made while the SDK was rendering.
    if (tabs.some((tab) => tab.classList.contains('active'))) {
      settled = true;
      return true;
    }

    settled = true;
    tabs[1].click();
    return true;
  };

  const scheduleOpen = () => {
    if (settled || openTimer) {
      return;
    }

    openTimer = window.setTimeout(() => {
      openTimer = undefined;

      if (openFieldsWhenReady()) {
        observer.disconnect();
      }
    }, 0);
  };

  const observer = new MutationObserver(scheduleOpen);
  observer.observe(container, { childList: true, subtree: true });
  scheduleOpen();

  return () => {
    window.clearTimeout(openTimer);
    observer.disconnect();
  };
};
